import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { Ability } from '../../models/Ability';
import { PortalUserService } from '../../services/portalUser.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-user-ability',
  templateUrl: './add-user-ability.component.html',
  styleUrls: ['./add-user-ability.component.scss']
})
export class AddUserAbilityComponent extends DialogContentBase implements OnInit {

  constructor(public dialog: DialogRef, 
    private fb: UntypedFormBuilder,
    private userService: PortalUserService, 
    private formUtilsService: FormUtilsService,
    public uiNotification: UiNotificationService,
    private translateService : TranslateService) {
    super(dialog);
  }

  ngOnInit(): void {
    this.initForm();
  }

  abilitiesList$: Observable<Ability[]>;
  @Input() public excludeAbilities: number[];
  @Input() public userId: string;

  assignAbilityForm: UntypedFormGroup;

  initForm(): void {

    this.assignAbilityForm = this.fb.group(
      {
        abilityId: [0, [Validators.required]]
      });

    this.abilitiesList$ = this.userService.getAllAbilities().pipe(
      map(x => x.filter(r => !this.excludeAbilities.includes(r.id))),
      tap(x => x.forEach(r => r.description = this.translateService.instant(r.description)))
      );
  }


  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  confirm() {

    if (!this.formUtilsService.markFormGroupTouched(this.assignAbilityForm)) {
      this.uiNotification.showValidationError();
      return;
    }

    const abilityId = this.assignAbilityForm.value.abilityId;

    this.userService.addUserAbility(this.userId, abilityId).subscribe(
      r => {
        this.uiNotification.showSuccess('validations.userAbilitiesUpdated');
        this.dialog.close({ text: 'OK' });
      });
  }
}
